module.exports = __webpack_public_path__ + "media/images/coins-f0240bf76a20d29bce4e3fc667eada95.png";